module.exports = __webpack_public_path__ + "static/mobile-centrifugal-pump-58921489d7a051ba1e4f2bf5f7a7de55.png";